import React, {Component} from 'react'
import '../../styles/Wyszukiwarka.css'
import Select from 'react-select'
import WyszukiwarkaService from "../WyszukiwarkaService";
import {Button} from "react-bootstrap";
import moment from "moment";
import * as acc from "accounting";
import {Link} from "react-router-dom";
import {NotificationManager} from "react-notifications";

export default class PokazSzczegoly extends Component {

    constructor(props) {
        super(props);

        let imie = '';
        let nazwisko = '';

        if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
            if (JSON.parse(sessionStorage.getItem('loggedIn')).imie !== null && JSON.parse(sessionStorage.getItem('loggedIn')).nazwisko !== null) {
                imie = JSON.parse(sessionStorage.getItem('loggedIn')).imie;
                nazwisko = JSON.parse(sessionStorage.getItem('loggedIn')).nazwisko
            }
        }

        console.log(this.props.powrotny)

        this.state = {
            typBiletu: [],
            typBiletu2: [],
            typyBiletow: [],
            typyBiletow2: [],
            dodano: true,
            imie: imie,
            nazwisko: nazwisko,
            cena: this.props.item.cena,
            cena2: this.props.item.cena,
            niepoprawneDaneImie: false,
            niepoprawneDaneNazwisko: false,
            loading: true,
            zalogujSie: false,
            uzupelnijDane: false,
            uzupelniony: false,
            idMiOd: '',
            idMiDo: '',
            idMiOdPrze: '',
            idMiDoPrze: '',
            powrotny: this.props.powrotny,
            showCennik: false,
            prom: '',
            prom2: ''
        };

        this.onChangeImie = this.onChangeImie.bind(this);
        this.onChangeNazwisko = this.onChangeNazwisko.bind(this);
        this.onChangeTypBiletu = this.onChangeTypBiletu.bind(this);
        this.onChangeTypBiletu2 = this.onChangeTypBiletu2.bind(this);
        this.handleDodajBiletZakup = this.handleDodajBiletZakup.bind(this);
        this.handleDodajBiletRezerwuj = this.handleDodajBiletRezerwuj.bind(this);
        this.showCennik = this.showCennik.bind(this)
    }

    showCennik() {
        this.setState({showCennik: !this.state.showCennik})
    }

    onChangeImie(e) {
        if (e.target.value.length > 0) {
            this.setState({niepoprawneDaneImie: false})
        }
        this.setState({imie: e.target.value})
    }

    onChangeNazwisko(e) {
        if (e.target.value.length > 0) {
            this.setState({niepoprawneDaneNazwisko: false})
        }
        this.setState({nazwisko: e.target.value})
    }

    onChangeTypBiletu(e) {
        if (e !== null) {
            if ((e.value === 'PROM' || this.state.typBiletu2.value === 'PROM') && sessionStorage.getItem('loggedIn') === null) {
                this.setState({typBiletu: e, zalogujSie: true, uzupelnijDane: false, cena: e.cena})
            } else {
                if ((e.value === 'PROM' || this.state.typBiletu2.value === 'PROM') && !this.state.uzupelniony) {
                    this.setState({typBiletu: e, zalogujSie: false, uzupelnijDane: true, cena: e.cena})
                } else {
                    this.setState({typBiletu: e, zalogujSie: false, uzupelnijDane: false, cena: e.cena})
                }
            }
        }
    }

    onChangeTypBiletu2(e) {
        if (e !== null) {
            if ((e.value === 'PROM' || this.state.typBiletu.value === 'PROM') && sessionStorage.getItem('loggedIn') === null) {
                this.setState({typBiletu2: e, zalogujSie: true, uzupelnijDane: false, cena2: e.cena})
            } else {
                if ((e.value === 'PROM' || this.state.typBiletu.value === 'PROM') && !this.state.uzupelniony) {
                    this.setState({typBiletu2: e, zalogujSie: false, uzupelnijDane: true, cena2: e.cena})
                } else {
                    this.setState({typBiletu2: e, zalogujSie: false, uzupelnijDane: false, cena2: e.cena})
                }
            }
        }
    }

    getTypKoszyka() {
        if (sessionStorage.getItem('koszyk') !== '[]' && sessionStorage.getItem('koszyk') !== null) {
            if (JSON.parse(sessionStorage.getItem('koszyk'))[0].statPoz === -1) {
                return '1'
            } else {
                return '0'
            }
        } else {
            return '2'
        }
    }

    handleDodajBiletZakup() {

        console.log(this.state.powrotny)

        let idPrOd = this.props.item.idPrOd;
        let idPrDo = this.props.item.idPrDo;
        let idMiOd = this.props.item.idMiOd;
        let idMiDo = this.props.item.idMiDo;
        let dataWyj = moment(this.props.params.data).add(1, 'days');

        if (this.state.powrotny) {
            dataWyj = moment(this.props.params.dataPow).add(1, 'days');
            console.log(moment(this.props.params.dataPow).add(1, 'days'))
        }

        let cena = this.state.cena;

        if (this.props.item.idKuPrze !== null) {
            cena = cena + this.state.cena2;
        }

        let promocyjny = false;


        if (sessionStorage.getItem('koszyk') !== undefined && sessionStorage.getItem('koszyk') !== null) {

            if (this.props.item.idKuPrze === null) {

                if (this.state.typBiletu.value === 'PROM') {
                    for (let i = 0; i < JSON.parse(sessionStorage.getItem('koszyk')).length; i++) {
                        if (JSON.parse(sessionStorage.getItem('koszyk'))[i].rodz === 'PROM' && JSON.parse(sessionStorage.getItem('koszyk'))[i].idKu === this.props.item.idKu) {
                            promocyjny = true
                        }
                        if (JSON.parse(sessionStorage.getItem('koszyk'))[i].rodz2 === 'PROM' && JSON.parse(sessionStorage.getItem('koszyk'))[i].idKuPrze === this.props.item.idKu) {
                            promocyjny = true
                        }
                    }
                }

            } else {

                if (this.state.typBiletu.value === 'PROM' || this.state.typBiletu2.value === 'PROM') {
                    for (let i = 0; i < JSON.parse(sessionStorage.getItem('koszyk')).length; i++) {
                        if (JSON.parse(sessionStorage.getItem('koszyk'))[i].rodz === 'PROM' && JSON.parse(sessionStorage.getItem('koszyk'))[i].idKuPrze === this.props.item.idKuPrze) {
                            promocyjny = true
                        }
                        if ((JSON.parse(sessionStorage.getItem('koszyk'))[i].rodz === 'PROM' && JSON.parse(sessionStorage.getItem('koszyk'))[i].idKu === this.props.item.idKu) || (JSON.parse(sessionStorage.getItem('koszyk'))[i].rodz2 === 'PROM' && JSON.parse(sessionStorage.getItem('koszyk'))[i].idKuPrze === this.props.item.idKuPrze)) {
                            promocyjny = true
                        }
                        if (JSON.parse(sessionStorage.getItem('koszyk'))[i].rodz === 'PROM' && JSON.parse(sessionStorage.getItem('koszyk'))[i].idKu === this.props.item.idKuPrze) {
                            promocyjny = true
                        }
                    }
                }
            }
        }

        if (promocyjny) {
            this.props.wyswietlNotyfikacje('promocyjny')
        } else {
            if (this.state.imie.length > 0 && this.state.nazwisko.length > 0) {
                let idKl = 1;

                if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
                    idKl = JSON.parse(sessionStorage.getItem('loggedIn')).idKl
                }

                let idPro = '';
                let idPro2 = '';

                if (this.state.typBiletu.idPro !== undefined && this.state.typBiletu.idPro !== null) {
                    idPro = this.state.typBiletu.idPro
                }

                if (this.state.typBiletu2.idPro !== undefined && this.state.typBiletu2.idPro !== null) {
                    idPro2 = this.state.typBiletu2.idPro
                }

                if (this.props.item.idKuPrze === null) {
                    WyszukiwarkaService.getSprawdzDostepne(this.props.item.idKu, idMiOd, idPrOd, idMiDo, idPro, this.state.typBiletu.value, 1, idKl).then((response) => {
                        if (response.data.uwaga === "OK") {
                            if (this.getTypKoszyka() === '1' || this.getTypKoszyka() === '2') {
                                let a;
                                let data = {
                                    id: Date.now(),
                                    cena: this.state.cena,
                                    cena2: this.state.cena2,
                                    data: dataWyj,
                                    dataOdjPrze: this.props.item.dataOdjPrze,
                                    godz: this.props.item.godz,
                                    godzPrze: this.props.item.godzPrze,
                                    godzPrzyPrze: this.props.item.godzPrzyPrze,
                                    idKu: this.props.item.idKu,
                                    idMiDo: idMiDo,
                                    idMiOd: idMiOd,
                                    idPrDo: idPrDo,
                                    idPrOd: idPrOd,
                                    idPrPrzeOd: this.props.item.idPrPrzeOd,
                                    idPrPrzeDo: this.props.item.idPrPrzeDo,
                                    idPro: idPro,
                                    idPro2: idPro2,
                                    idKuPrze: this.props.item.idKuPrze,
                                    idTr: this.props.item.idTr,
                                    idTrPrze: this.props.item.idTrPrze,
                                    ile: 1,
                                    klient: this.state.nazwisko + ' ' + this.state.imie,
                                    rodz: this.state.typBiletu.value,
                                    rodzaj: this.state.typBiletu.label,
                                    rodz2: this.state.typBiletu2.value,
                                    rodzaj2: this.state.typBiletu2.label,
                                    statPoz: -1,
                                    nazMiOd: this.props.item.nazMiOd,
                                    nazMiPrze: this.props.item.nazMiPrze,
                                    nazPrPrzeDo: this.props.item.nazPrPrzeDo,
                                    nazPrPrzeOd: this.props.item.nazPrPrzeOd,
                                    nazMiDo: this.props.item.nazMiDo,
                                    nazPrOd: this.props.item.nazPrOd,
                                    nazPrDo: this.props.item.nazPrDo,
                                    godzPrzy: this.props.item.godzPrzy,
                                    typ: 'J',
                                    powrotny: this.state.powrotny,
                                };
                                if (sessionStorage.getItem('koszyk') === null) {
                                    a = [];
                                } else {
                                    a = JSON.parse(sessionStorage.getItem('koszyk'))
                                }
                                a.push(data);
                                sessionStorage.setItem('koszyk', JSON.stringify(a));
                                this.props.koszyk();
                                this.props.wyswietlNotyfikacje('zakup');
                                this.props.odswiezPozycje();
                                this.setState({
                                    imie: '',
                                    nazwisko: '',
                                    niepoprawneDane: false
                                })
                            } else {
                                this.props.wyswietlNotyfikacje('tylkoRezerwacja')
                            }
                        } else {
                            this.props.wyswietlUwage(response.data.uwaga)
                        }
                    })
                } else {
                    WyszukiwarkaService.getSprawdzDostepne(this.props.item.idKu, idMiOd, idPrOd, 79, idPro, this.state.typBiletu.value, 1, idKl).then((response) => {
                        if (response.data.uwaga === "OK") {
                            WyszukiwarkaService.getSprawdzDostepne(this.props.item.idKuPrze, 79, this.props.item.idPrPrzeDo, idMiDo, idPro2, this.state.typBiletu2.value, 1, idKl).then((res) => {
                                if (res.data.uwaga === "OK") {
                                    if (this.getTypKoszyka() === '1' || this.getTypKoszyka() === '2') {
                                        let a;
                                        let data = {
                                            id: Date.now(),
                                            cena: this.state.cena,
                                            cena2: this.state.cena2,
                                            data: dataWyj,
                                            dataOdjPrze: this.props.item.dataOdjPrze,
                                            godz: this.props.item.godz,
                                            godzPrze: this.props.item.godzPrze,
                                            godzPrzyPrze: this.props.item.godzPrzyPrze,
                                            idKu: this.props.item.idKu,
                                            idMiDo: idMiDo,
                                            idMiOd: idMiOd,
                                            idPrDo: idPrDo,
                                            idPrOd: idPrOd,
                                            idPrPrzeOd: this.props.item.idPrPrzeOd,
                                            idPrPrzeDo: this.props.item.idPrPrzeDo,
                                            idPro: idPro,
                                            idPro2: idPro2,
                                            idKuPrze: this.props.item.idKuPrze,
                                            idTr: this.props.item.idTr,
                                            idTrPrze: this.props.item.idTrPrze,
                                            ile: 1,
                                            klient: this.state.nazwisko + ' ' + this.state.imie,
                                            rodz: this.state.typBiletu.value,
                                            rodzaj: this.state.typBiletu.label,
                                            rodz2: this.state.typBiletu2.value,
                                            rodzaj2: this.state.typBiletu2.label,
                                            statPoz: -1,
                                            nazMiOd: this.props.item.nazMiOd,
                                            nazMiPrze: this.props.item.nazMiPrze,
                                            nazPrPrzeDo: this.props.item.nazPrPrzeDo,
                                            nazPrPrzeOd: this.props.item.nazPrPrzeOd,
                                            nazMiDo: this.props.item.nazMiDo,
                                            nazPrOd: this.props.item.nazPrOd,
                                            nazPrDo: this.props.item.nazPrDo,
                                            godzPrzy: this.props.item.godzPrzy,
                                            typ: 'J',
                                            powrotny: this.state.powrotny,
                                        };
                                        if (sessionStorage.getItem('koszyk') === null) {
                                            a = [];
                                        } else {
                                            a = JSON.parse(sessionStorage.getItem('koszyk'))
                                        }
                                        a.push(data);
                                        sessionStorage.setItem('koszyk', JSON.stringify(a));
                                        this.props.koszyk();
                                        this.props.wyswietlNotyfikacje('zakup');
                                        this.props.odswiezPozycje();
                                        this.setState({
                                            imie: '',
                                            nazwisko: '',
                                            niepoprawneDane: false
                                        })
                                    } else {
                                        this.props.wyswietlNotyfikacje('tylkoRezerwacja')
                                    }
                                } else {
                                    this.props.wyswietlUwage(res.data.uwaga)
                                }
                            })
                        } else {
                            this.props.wyswietlUwage(response.data.uwaga)
                        }
                    })
                }
            } else {
                this.setState({niepoprawneDane: true})
            }
        }
    }

    handleDodajBiletRezerwuj() {

        let idPrOd = this.props.item.idPrOd;
        let idPrDo = this.props.item.idPrDo;
        let idMiOd = this.props.item.idMiOd;
        let idMiDo = this.props.item.idMiDo;
        let dataWyj = moment(this.props.params.data).add(1, 'days');

        if (this.state.powrotny) {
            dataWyj = moment(this.props.params.dataPow).add(1, 'days');
        }

        let promocyjny = false;

        if (this.state.typBiletu.value === 'PROM') {
            if (sessionStorage.getItem('koszyk') !== undefined && sessionStorage.getItem('koszyk') !== null) {
                for (let i = 0; i < JSON.parse(sessionStorage.getItem('koszyk')).length; i++) {
                    if (JSON.parse(sessionStorage.getItem('koszyk'))[i].rodz === 'PROM' && JSON.parse(sessionStorage.getItem('koszyk'))[i].idKu === this.props.item.idKu) {
                        promocyjny = true
                    }
                }
            }
        }

        if (promocyjny) {
            this.props.wyswietlNotyfikacje('promocyjny')
        } else {
            if (this.state.imie.length > 0 && this.state.nazwisko.length > 0) {
                let idKl = 1;

                if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
                    idKl = JSON.parse(sessionStorage.getItem('loggedIn')).idKl
                }

                let idPro = '';
                let idPro2 = '';

                if (this.state.typBiletu.idPro !== undefined && this.state.typBiletu.idPro !== null) {
                    idPro = this.state.typBiletu.idPro
                }

                if (this.state.typBiletu2.idPro !== undefined && this.state.typBiletu2.idPro !== null) {
                    idPro2 = this.state.typBiletu2.idPro
                }

                if (this.props.item.idKuPrze === null) {
                    WyszukiwarkaService.getSprawdzDostepne(this.props.item.idKu, idMiOd, idPrOd, idMiDo, idPro, this.state.typBiletu.value, 1, idKl).then((response) => {
                        if (response.data.uwaga === "OK") {
                            if (this.getTypKoszyka() === '0' || this.getTypKoszyka() === '2') {
                                let a;
                                let data = {
                                    id: Date.now(),
                                    cena: this.state.cena,
                                    cena2: this.state.cena2,
                                    data: dataWyj,
                                    godz: this.props.item.godz,
                                    godzPrze: this.props.item.godzPrze,
                                    godzPrzyPrze: this.props.item.godzPrzyPrze,
                                    idKu: this.props.item.idKu,
                                    idMiDo: idMiDo,
                                    idMiOd: idMiOd,
                                    idPrDo: idPrDo,
                                    idPrOd: idPrOd,
                                    idPrPrzeOd: this.props.item.idPrPrzeOd,
                                    idPrPrzeDo: this.props.item.idPrPrzeDo,
                                    dataOdjPrze: this.props.item.dataOdjPrze,
                                    idPro: idPro,
                                    idPro2: idPro2,
                                    idKuPrze: this.props.item.idKuPrze,
                                    idTr: this.props.item.idTr,
                                    idTrPrze: this.props.item.idTrPrze,
                                    ile: 1,
                                    klient: this.state.nazwisko + ' ' + this.state.imie,
                                    rodz: this.state.typBiletu.value,
                                    rodzaj: this.state.typBiletu.label,
                                    rodz2: this.state.typBiletu2.value,
                                    rodzaj2: this.state.typBiletu2.label,
                                    statPoz: 0,
                                    nazMiOd: this.props.item.nazMiOd,
                                    nazMiPrze: this.props.item.nazMiPrze,
                                    nazPrPrzeDo: this.props.item.nazPrPrzeDo,
                                    nazPrPrzeOd: this.props.item.nazPrPrzeOd,
                                    nazMiDo: this.props.item.nazMiDo,
                                    nazPrOd: this.props.item.nazPrOd,
                                    nazPrDo: this.props.item.nazPrDo,
                                    godzPrzy: this.props.item.godzPrzy,
                                    typ: 'J',
                                    powrotny: this.state.powrotny,
                                };
                                if (sessionStorage.getItem('koszyk') === null) {
                                    a = [];
                                } else {
                                    a = JSON.parse(sessionStorage.getItem('koszyk'))
                                }
                                a.push(data);
                                sessionStorage.setItem('koszyk', JSON.stringify(a));
                                this.props.koszyk();
                                this.props.wyswietlNotyfikacje('rezerwacja');
                                this.props.odswiezPozycje();
                                this.setState({
                                    imie: '',
                                    nazwisko: '',
                                    niepoprawneDane: false
                                })
                            } else {
                                this.props.wyswietlNotyfikacje('tylkoZakup')
                            }
                        } else {
                            this.props.wyswietlUwage(response.data.uwaga)
                        }
                    })
                } else {
                    WyszukiwarkaService.getSprawdzDostepne(this.props.item.idKu, idMiOd, idPrOd, 79, idPro, this.state.typBiletu.value, 1, idKl).then((response) => {
                        if (response.data.uwaga === "OK") {
                            WyszukiwarkaService.getSprawdzDostepne(this.props.item.idKuPrze, 79, idPrOd, idMiDo, idPro2, this.state.typBiletu2.value, 1, idKl).then((res) => {
                                if (res.data.uwaga === "OK") {
                                    if (this.getTypKoszyka() === '0' || this.getTypKoszyka() === '2') {
                                        let a;
                                        let data = {
                                            id: Date.now(),
                                            cena: this.state.cena,
                                            cena2: this.state.cena2,
                                            data: dataWyj,
                                            godz: this.props.item.godz,
                                            godzPrze: this.props.item.godzPrze,
                                            godzPrzyPrze: this.props.item.godzPrzyPrze,
                                            idKu: this.props.item.idKu,
                                            idMiDo: idMiDo,
                                            idMiOd: idMiOd,
                                            idPrDo: idPrDo,
                                            idPrOd: idPrOd,
                                            idPrPrzeOd: this.props.item.idPrPrzeOd,
                                            idPrPrzeDo: this.props.item.idPrPrzeDo,
                                            dataOdjPrze: this.props.item.dataOdjPrze,
                                            idPro: idPro,
                                            idPro2: idPro2,
                                            idKuPrze: this.props.item.idKuPrze,
                                            idTr: this.props.item.idTr,
                                            idTrPrze: this.props.item.idTrPrze,
                                            ile: 1,
                                            klient: this.state.nazwisko + ' ' + this.state.imie,
                                            rodz: this.state.typBiletu.value,
                                            rodzaj: this.state.typBiletu.label,
                                            rodz2: this.state.typBiletu2.value,
                                            rodzaj2: this.state.typBiletu2.label,
                                            statPoz: 0,
                                            nazMiOd: this.props.item.nazMiOd,
                                            nazMiPrze: this.props.item.nazMiPrze,
                                            nazPrPrzeDo: this.props.item.nazPrPrzeDo,
                                            nazPrPrzeOd: this.props.item.nazPrPrzeOd,
                                            nazMiDo: this.props.item.nazMiDo,
                                            nazPrOd: this.props.item.nazPrOd,
                                            nazPrDo: this.props.item.nazPrDo,
                                            godzPrzy: this.props.item.godzPrzy,
                                            typ: 'J',
                                            powrotny: this.state.powrotny,
                                        };
                                        if (sessionStorage.getItem('koszyk') === null) {
                                            a = [];
                                        } else {
                                            a = JSON.parse(sessionStorage.getItem('koszyk'))
                                        }
                                        a.push(data);
                                        sessionStorage.setItem('koszyk', JSON.stringify(a));
                                        this.props.koszyk();
                                        this.props.wyswietlNotyfikacje('rezerwacja');
                                        this.props.odswiezPozycje();
                                        this.setState({
                                            imie: '',
                                            nazwisko: '',
                                            niepoprawneDane: false
                                        })
                                    } else {
                                        this.props.wyswietlNotyfikacje('tylkoZakup')
                                    }
                                } else {
                                    this.props.wyswietlUwage(res.data.uwaga)
                                }
                            })
                        } else {
                            this.props.wyswietlUwage(response.data.uwaga)
                        }
                    })
                }
            } else {
                this.setState({niepoprawneDane: true})
            }
        }
    }

    componentWillMount() {
        // let uzupelniony = false;
        let uzupelniony = true;
        if (sessionStorage.getItem('loggedIn') !== null) {
            WyszukiwarkaService.getUzupelnione(JSON.parse(sessionStorage.getItem('loggedIn')).idKl)
                .then(function (response) {
                    // this.setState({uzupelniony: response.data.uzupelniony});
                    this.setState({uzupelniony: true});
                    uzupelniony = response.data.uzupelniony;
                }.bind(this)).then(() => {
                this.getZnizkiBiletow(uzupelniony)
            })
        } else {
            this.getZnizkiBiletow(true)
        }
    }

    getZnizkiBiletow(uzupelniony) {

        uzupelniony = true;
        let zalogujSie = false;

        if (this.props.item.idKuPrze === null) {
            if (this.state.powrotny === true) {
                WyszukiwarkaService.getZnizki(this.props.item.idKu, this.props.item.idMiDo, this.props.item.idMiOd)
                    .then(function (response) {
                        let res = response.data;
                        let typyBiletow = [];
                        let typBiletu;
                        for (let i = 0; i < res.length; i++) {
                            if (res[i].idPro === null && res[i].rodz === 'PROM') {

                            } else {
                                if (res[i].rodz === 'PROM') {
                                    this.setState({prom: res[i]});
                                }
                                typyBiletow.push({
                                    value: res[i].rodz, label: res[i].nazZniz, cena: res[i].cena,
                                    ustawowa: res[i].ustawowa, handlowa: res[i].handlowa, idPro: res[i].idPro
                                })
                            }
                        }

                        if ((typyBiletow[0].value === 'PROM') && sessionStorage.getItem('loggedIn') === null) {
                            zalogujSie = true;
                        }

                        this.setState({
                            typyBiletow: typyBiletow,
                            typBiletu: typyBiletow[0],
                            zalogujSie: zalogujSie,
                            uzupelnijDane: !uzupelniony,
                            cena: typyBiletow[0].cena,
                            loading: false
                        })
                    }.bind(this))
            } else {
                WyszukiwarkaService.getZnizki(this.props.item.idKu, this.props.item.idMiDo, this.props.item.idMiOd)
                    .then(function (response) {
                        let res = response.data;
                        let typyBiletow = [];
                        let typBiletu;
                        for (let i = 0; i < res.length; i++) {
                            if (res[i].idPro === null && res[i].rodz === 'PROM') {

                            } else {
                                if (res[i].rodz === 'PROM') {
                                    this.setState({prom: res[i]});
                                }
                                typyBiletow.push({
                                    value: res[i].rodz,
                                    label: res[i].nazZniz,
                                    cena: res[i].cena,
                                    ustawowa: res[i].ustawowa,
                                    handlowa: res[i].handlowa,
                                    idPro: res[i].idPro
                                })
                            }
                        }

                        if (typyBiletow.length !== 0) {
                            if ((typyBiletow[0].value === 'PROM') && sessionStorage.getItem('loggedIn') === null) {
                                zalogujSie = true;
                            }
                        }

                        if (typyBiletow.length !== 0) {
                            this.setState({
                                typyBiletow: typyBiletow,
                                typBiletu: typyBiletow[0],
                                zalogujSie: zalogujSie,
                                uzupelnijDane: !uzupelniony,
                                cena: typyBiletow[0].cena,
                                loading: false
                            })
                        } else {
                            NotificationManager.error('Wystąpił błąd podczas ładowania cennika biletów', "Błąd", 10000);
                            this.setState({loading: false})
                        }

                    }.bind(this))
            }
        } else {
            if (this.state.powrotny) {
                WyszukiwarkaService.getZnizkiLaczone(this.props.item.idKu, this.props.item.idKuPrze, this.props.item.idMiOd, this.props.item.idMiPrze, this.props.item.idMiDo)
                    .then(function (response) {
                        let res = response.data[this.props.item.idKu];
                        let res2 = response.data[this.props.item.idKuPrze];
                        let typyBiletow = [];
                        let typyBiletow2 = [];
                        let typBiletu;
                        let typBiletu2;
                        for (let i = 0; i < res.length; i++) {
                            if (res[i].idPro === null && res[i].rodz === 'PROM') {

                            } else {
                                if (res[i].rodz === 'PROM') {
                                    this.setState({prom: res[i]});
                                }
                                typyBiletow.push({
                                    value: res[i].rodz, label: res[i].nazZniz, cena: res[i].cena,
                                    ustawowa: res[i].ustawowa,
                                    handlowa: res[i].handlowa,
                                    idPro: res[i].idPro
                                })
                            }
                        }
                        for (let i = 0; i < res2.length; i++) {
                            if (res2[i].idPro === null && res2[i].rodz === 'PROM') {

                            } else {
                                if (res2[i].rodz === 'PROM') {
                                    this.setState({prom2: res2[i]});
                                }
                                typyBiletow2.push({
                                    value: res2[i].rodz, label: res2[i].nazZniz, cena: res2[i].cena,
                                    ustawowa: res2[i].ustawowa,
                                    handlowa: res2[i].handlowa,
                                    idPro: res2[i].idPro
                                })
                            }
                        }

                        if ((typyBiletow[0].value === 'PROM' || typyBiletow2[0].value === 'PROM') && sessionStorage.getItem('loggedIn') === null) {
                            zalogujSie = true;
                        }

                        this.setState({
                            typyBiletow: typyBiletow,
                            typyBiletow2: typyBiletow2,
                            typBiletu: typyBiletow[0],
                            typBiletu2: typyBiletow2[0],
                            zalogujSie: zalogujSie,
                            uzupelnijDane: !uzupelniony,
                            cena: typyBiletow[0].cena,
                            cena2: typyBiletow2[0].cena,
                            loading: false
                        })
                    }.bind(this))
            } else {
                WyszukiwarkaService.getZnizkiLaczone(this.props.item.idKu, this.props.item.idKuPrze, this.props.item.idMiOd, this.props.item.idMiPrze, this.props.item.idMiDo)
                    .then(function (response) {
                        let res = response.data[this.props.item.idKu];
                        let res2 = response.data[this.props.item.idKuPrze];
                        let typyBiletow = [];
                        let typyBiletow2 = [];
                        let typBiletu;
                        let typBiletu2;
                        for (let i = 0; i < res.length; i++) {
                            if (res[i].idPro === null && res[i].rodz === 'PROM') {

                            } else {
                                if (res[i].rodz === 'PROM') {
                                    this.setState({prom: res[i]});
                                }
                                typyBiletow.push({
                                    value: res[i].rodz, label: res[i].nazZniz, cena: res[i].cena,
                                    ustawowa: res[i].ustawowa,
                                    handlowa: res[i].handlowa,
                                    idPro: res[i].idPro
                                })
                            }
                        }
                        for (let i = 0; i < res2.length; i++) {
                            if (res2[i].idPro === null && res2[i].rodz === 'PROM') {

                            } else {
                                if (res2[i].rodz === 'PROM') {
                                    this.setState({prom2: res2[i]});
                                }
                                typyBiletow2.push({
                                    value: res2[i].rodz, label: res2[i].nazZniz, cena: res2[i].cena,
                                    ustawowa: res2[i].ustawowa,
                                    handlowa: res2[i].handlowa,
                                    idPro: res2[i].idPro
                                })
                            }
                        }

                        if ((typyBiletow[0].value === 'PROM' || typyBiletow2[0].value === 'PROM') && sessionStorage.getItem('loggedIn') === null) {
                            zalogujSie = true;
                        }

                        this.setState({
                            typyBiletow: typyBiletow,
                            typyBiletow2: typyBiletow2,
                            typBiletu: typyBiletow[0],
                            typBiletu2: typyBiletow2[0],
                            zalogujSie: zalogujSie,
                            uzupelnijDane: !uzupelniony,
                            cena: typyBiletow[0].cena,
                            cena2: typyBiletow2[0].cena,
                            loading: false
                        })
                    }.bind(this))
            }
        }
    }

    typRenderer(option) {
        return <div className={'row'}>
            <div className={'col-9'}>{option.label}</div>
            <div className={'col-3 text-right'}><span className={'cenaRender'}>{acc.formatMoney(option.cena, {
                format: '%v%s',
                symbol: " zł"
            })}</span></div>
        </div>
    }

    render() {

        let item = this.props.item;

        return <div>
            {!this.state.loading ?
                <div>
                    <hr style={{borderTop: '2px solid #57b13caa'}}/>
                    <div className="row" style={{marginLeft: 5, marginRight: 5, marginTop: 10}}>
                        <div className="col-sm-11"><h5>Kup
                            bilet{this.props.item.idKuPrze !== null ? " na trasę " + this.props.item.nazTr : null}:
                            {this.state.prom !== '' ?
                                <span className={'promoDostepne'}><i className={'fa fa-info-circle'}
                                                                     style={{marginRight: 3}}/> Dostępny bilet promocyjny
                                    w
                                    cenie {acc.formatMoney(this.state.prom.cena, {
                                        format: '%v%s',
                                        symbol: " zł"
                                    })}</span> : null}
                        </h5>
                        </div>
                        <div className={'col-sm-1'}>
                            <span className="zamknijSzczegolyMobilka"
                                  style={{fontSize: 18, textAlign: 'right', color: 'red', marginLeft: 15}}><span
                                style={{cursor: 'pointer'}}
                                onClick={() => this.props.pokazSzczegoly(item.idKu)}>x</span>
                            </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-9 biletPromocyjnyTextContainer">
                            {this.state.typBiletu.value === 'PROM' ?
                                <div className="biletPromocyjnyText" style={{color: 'black', padding: 0}}>Możesz dodać
                                    tylko jeden
                                    bilet promocyjny na dany kurs.</div> : null}
                        </div>
                    </div>
                    <div className={"row szczegolyMobilka"} style={{marginLeft: 5, marginRight: 5, marginTop: 10}}>
                        <div className="col-sm-1 typBiletuMobilka"
                             style={{textAlign: 'right', fontSize: '0.875rem', margin: 0, padding: 0, paddingTop: 6}}>
                            Typ biletu:
                        </div>
                        <div className="col-sm-7" style={{paddingLeft: 15, paddingRight: 5}}>
                            <Select placeholder="Wybierz typ biletu"
                                    value={this.state.typBiletu}
                                    onChange={this.onChangeTypBiletu}
                                    clearable={false}
                                    optionRenderer={this.typRenderer}
                                    options={this.state.typyBiletow}
                                    matchPos="start"
                                    noResultsText={"Brak biletu"}/>
                        </div>
                        <div className="col-sm-4 cena" style={{paddingTop: 2, lineHeight: '34px'}}>
                            Cena: <span>{acc.formatMoney(this.state.cena, {format: '%v%s', symbol: " zł"})}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-9 biletPromocyjnyTextContainer">
                            {this.state.zalogujSie && this.state.typBiletu.value === 'PROM' ?
                                <div className="biletPromocyjnyText">Aby kupić bilet promocyjny należy się <Link
                                    to={'/konto/dane'} onClick={() => {
                                    sessionStorage.setItem('link', window.location.href);
                                }}>zalogować</Link>.</div> : null}
                            {!this.state.zalogujSie && this.state.uzupelnijDane && this.state.typBiletu.value === 'PROM' ?
                                <div className="biletPromocyjnyText">Aby kupić bilet promocyjny należy <Link
                                    to={'/konto/dane'} onClick={() => {
                                    sessionStorage.setItem('link', window.location.href);
                                }}>uzupełnić dane osobowe</Link>.</div> : null}
                        </div>
                    </div>
                    {this.props.item.idKuPrze === null ? <div className={"row"} style={{
                        marginLeft: 5,
                        marginRight: 5,
                        marginTop: 10,
                        textAlign: 'center'
                    }}>
                        <div className="col-sm-1 typBiletuMobilka"
                             style={{textAlign: 'right', fontSize: '0.875rem', margin: 0, padding: 0, paddingTop: 6}}>
                            Imię:
                        </div>
                        <div className="col-sm-3" style={{paddingLeft: 15, paddingRight: 5}}>
                            <input type="text" className="form-control" placeholder="Imię"
                                   value={this.state.imie} maxLength="30" onChange={this.onChangeImie}/>
                        </div>
                        <div className="col-sm-1 typBiletuMobilka"
                             style={{textAlign: 'right', fontSize: '0.875rem', margin: 0, padding: 0, paddingTop: 6}}>
                            Nazwisko:
                        </div>
                        <div className="col-sm-3" style={{paddingLeft: 15, paddingRight: 5}}>
                            <input type="text" className="form-control" placeholder="Nazwisko"
                                   value={this.state.nazwisko} maxLength="30" onChange={this.onChangeNazwisko}/>
                        </div>

                        <div className="col-sm-2 rezerwacjaMobilka" style={{textAlign: 'center', margin: 0, padding: 0}}
                             data-tip
                             data-for={(item.idKu).toString()}
                             data-place="bottom">
                            {this.state.typBiletu.value !== "PROM" ? <div>
                                {/*{this.state.zalogujSie || this.state.uzupelnijDane || !item.czyERezerwacja ?*/}
                                {/*    <ReactTooltip*/}
                                {/*        id={item.idKu.toString()}>*/}
                                {/*        <div className="text-left">*/}
                                {/*            Brak możliwości rezerwacji biletu na danej trasie.*/}
                                {/*        </div>*/}
                                {/*    </ReactTooltip> : null}*/}
                                {(this.state.typBiletu.value === "PROM" || sessionStorage.getItem('loggedIn') === null || sessionStorage.getItem('loggedIn') === undefined || !this.state.uzupelniony) ? null :
                                    <Button
                                        style={this.state.zalogujSie || this.state.uzupelnijDane || !item.czyERezerwacja ? {
                                            display: 'none'
                                        } : {background: '#eeb207', color: 'white'}}
                                        disabled={this.state.zalogujSie || this.state.uzupelnijDane || !item.czyERezerwacja}
                                        onClick={() => {
                                            this.handleDodajBiletRezerwuj()
                                        }}><i
                                        className="fa fa-cart-arrow-down"> </i> Rezerwacja</Button>}
                            </div> : null}
                        </div>
                        <div className="col-sm-2 zakupMobilka" style={{textAlign: 'left', margin: 0, padding: 0}}>
                            <Button
                                bsStyle={this.state.zalogujSie || (!this.state.uzupelniony && this.state.typBiletu.value === "PROM") ? 'disabled' : 'primary'}
                                disabled={this.state.zalogujSie || (!this.state.uzupelniony && this.state.typBiletu.value === "PROM")}
                                style={{width: 125, textAlign: 'center'}}
                                onClick={this.handleDodajBiletZakup}><i
                                className="fa fa-cart-plus" style={{paddingRight: 5}}> </i> Kup</Button>
                        </div>

                    </div> : null}
                    {this.props.item.idKuPrze !== null ? null : <div className={"row"} style={{
                        marginLeft: 5,
                        marginRight: 5,
                        marginTop: 10,
                        textAlign: 'center'
                    }}>
                        {this.state.niepoprawneDane ?
                            <div className="niepoprawneDane col-sm-6" style={{fontSize: '0.875rem'}}>
                                <font>{this.state.imie.length === 0 && this.state.nazwisko.length === 0 ? 'Pola imię i nazwisko nie mogą być puste.' : null}</font>
                                <font>{this.state.imie.length === 0 && this.state.nazwisko.length !== 0 ? 'Pole imię nie może być puste.' : null}</font>
                                <font>{this.state.imie.length !== 0 && this.state.nazwisko.length === 0 ? 'Pole nazwisko nie może być puste.' : null}</font>
                            </div> : null}
                    </div>}
                </div>
                :
                <div>
                    <hr/>
                    <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div>}
            {this.props.item.idKuPrze !== null ?
                <div>{!this.state.loading ?
                    <div>
                        <hr/>
                        <div className="row" style={{marginLeft: 5, marginRight: 5, marginTop: 10}}>
                            <div className="col-sm-12"><h5>Kup
                                bilet{this.props.item.idKuPrze !== null ? " na trasę " + this.props.item.nazTrPrze : null}:
                                {this.state.prom2 !== '' ?
                                    <div className={'promoDostepne'}><i className={'fa fa-info-circle'}
                                                                        style={{marginRight: 3}}/> Dostępny bilet
                                        promocyjny w
                                        cenie {acc.formatMoney(this.state.prom2.cena, {
                                            format: '%v%s',
                                            symbol: " zł"
                                        })}</div> : null}
                            </h5>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-9 biletPromocyjnyTextContainer">
                                {this.state.typBiletu2.value === 'PROM' ?
                                    <div className="biletPromocyjnyText" style={{color: 'black', padding: 0}}>Możesz
                                        dodać
                                        tylko jeden
                                        bilet promocyjny na dany kurs.</div> : null}
                            </div>
                        </div>
                        <div className={"row szczegolyMobilka"} style={{marginLeft: 5, marginRight: 5, marginTop: 10}}>
                            <div className="col-sm-1 typBiletuMobilka"
                                 style={{
                                     textAlign: 'right',
                                     fontSize: '0.875rem',
                                     margin: 0,
                                     padding: 0,
                                     paddingTop: 6
                                 }}>
                                Typ biletu:
                            </div>
                            <div className="col-sm-7" style={{paddingLeft: 15, paddingRight: 5}}>
                                <Select placeholder="Wybierz typ biletu"
                                        value={this.state.typBiletu2}
                                        onChange={this.onChangeTypBiletu2}
                                        clearable={false}
                                        optionRenderer={this.typRenderer}
                                        options={this.state.typyBiletow2}
                                        matchPos="start"
                                        noResultsText={"Brak biletu"}/>
                            </div>
                            <div className="col-sm-4 cena" style={{paddingTop: 2, lineHeight: '34px'}}>
                                Cena: <span>{acc.formatMoney(this.state.cena2, {format: '%v%s', symbol: " zł"})}</span>
                            </div>
                        </div>
                        <hr style={{marginTop: 25}}/>
                        <div className="row">
                            <div className="col-9 biletPromocyjnyTextContainer">
                                {this.state.zalogujSie && this.state.typBiletu2.value === 'PROM' ?
                                    <div className="biletPromocyjnyText">Aby kupić bilet promocyjny należy się <Link
                                        to={'/konto/dane'} onClick={() => {
                                        sessionStorage.setItem('link', window.location.href);
                                    }}>zalogować</Link>.</div> : null}
                                {this.state.uzupelnijDane && this.state.typBiletu2.value === 'PROM' ?
                                    <div className="biletPromocyjnyText">Aby kupić bilet promocyjny należy <Link
                                        to={'/konto/dane'} onClick={() => {
                                        sessionStorage.setItem('link', window.location.href);
                                    }}>uzupełnić dane osobowe</Link>.</div> : null}
                            </div>
                        </div>
                        <div className={"row"}
                             style={{marginLeft: 5, marginRight: 5, marginTop: 10, textAlign: 'center'}}>
                            <div className="col-sm-1 typBiletuMobilka"
                                 style={{
                                     textAlign: 'right',
                                     fontSize: '0.875rem',
                                     margin: 0,
                                     padding: 0,
                                     paddingTop: 6
                                 }}>
                                Imię:
                            </div>
                            <div className="col-sm-3" style={{paddingLeft: 15, paddingRight: 5}}>
                                <input type="text" className="form-control" placeholder="Imię"
                                       value={this.state.imie} maxLength="30" onChange={this.onChangeImie}/>
                            </div>
                            <div className="col-sm-1 typBiletuMobilka"
                                 style={{
                                     textAlign: 'right',
                                     fontSize: '0.875rem',
                                     margin: 0,
                                     padding: 0,
                                     paddingTop: 6
                                 }}>
                                Nazwisko:
                            </div>
                            <div className="col-sm-3" style={{paddingLeft: 15, paddingRight: 5}}>
                                <input type="text" className="form-control" placeholder="Nazwisko"
                                       value={this.state.nazwisko} maxLength="30" onChange={this.onChangeNazwisko}/>
                            </div>

                            <div className="col-sm-2 rezerwacjaMobilka"
                                 style={{textAlign: 'center', margin: 0, padding: 0}}
                                 data-tip
                                 data-for={(item.idKu).toString()}
                                 data-place="bottom">
                                {this.state.typBiletu.value !== "PROM" ? <div>
                                    {/*{this.state.zalogujSie || this.state.uzupelnijDane || !item.czyERezerwacja ?*/}
                                    {/*    <ReactTooltip*/}
                                    {/*        id={item.idKu.toString()}>*/}
                                    {/*        <div className="text-left">*/}
                                    {/*            Brak możliwości rezerwacji biletu na danej trasie.*/}
                                    {/*        </div>*/}
                                    {/*    </ReactTooltip> : null}*/}
                                    {(this.state.typBiletu.value === "PROM" || this.state.typBiletu2.value === "PROM" || sessionStorage.getItem('loggedIn') === null || sessionStorage.getItem('loggedIn') === undefined || !this.state.uzupelniony) ? null :
                                        <Button
                                            style={this.state.zalogujSie || this.state.uzupelnijDane || !item.czyERezerwacja ? {
                                                display: 'none'
                                            } : {background: '#eeb207', color: 'white'}}
                                            disabled={this.state.zalogujSie || this.state.uzupelnijDane || !item.czyERezerwacja}
                                            onClick={() => {
                                                this.handleDodajBiletRezerwuj()
                                            }}><i
                                            className="fa fa-cart-arrow-down"> </i> Rezerwacja</Button>}
                                </div> : null}
                            </div>
                            <div className="col-sm-2 zakupMobilka" style={{textAlign: 'left', margin: 0, padding: 0}}>
                                <Button
                                    bsStyle={this.state.zalogujSie || (!this.state.uzupelniony && (this.state.typBiletu.value === "PROM" || this.state.typBiletu2.value === "PROM")) ? 'disabled' : 'primary'}
                                    disabled={this.state.zalogujSie || (!this.state.uzupelniony && (this.state.typBiletu.value === "PROM" || this.state.typBiletu2.value === "PROM"))}
                                    style={{width: 125, textAlign: 'center'}}
                                    onClick={this.handleDodajBiletZakup}><i
                                    className="fa fa-cart-plus" style={{paddingRight: 5}}> </i> Kup</Button>
                            </div>

                        </div>
                        <div className={"row"}
                             style={{marginLeft: 5, marginRight: 5, marginTop: 10, textAlign: 'center'}}>
                            {this.state.niepoprawneDane ?
                                <div className="niepoprawneDane col-sm-6" style={{fontSize: '0.875rem'}}>
                                    <font>{this.state.imie.length === 0 && this.state.nazwisko.length === 0 ? 'Pola imię i nazwisko nie mogą być puste.' : null}</font>
                                    <font>{this.state.imie.length === 0 && this.state.nazwisko.length !== 0 ? 'Pole imię nie może być puste.' : null}</font>
                                    <font>{this.state.imie.length !== 0 && this.state.nazwisko.length === 0 ? 'Pole nazwisko nie może być puste.' : null}</font>
                                </div> : null}
                        </div>
                    </div>
                    :
                    <div>
                        <hr/>
                        <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                            className="fa fa-spinner fa-pulse fa-2x fa-fw"
                            style={{
                                color: '#58b13d'
                            }}> </i></div>
                    </div>}</div> : null}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/wyszukiwarkaComponents/PokazSzczegoly.js